import { sleep } from "@/utils";
import { useEffect } from "react";

export const useCallbackOnInterval = (
  method: (isRefresh?: boolean) => Promise<unknown>,
  _delay?: number
) => {
  const delay = typeof _delay === "number" ? _delay : null;

  useEffect(() => {
    if (delay === null) {
      method(false);
      return;
    }

    let isRunning = true;
    let isRefresh = false;

    const run = async () => {
      for (;;) {
        if (!isRunning) {
          break;
        }

        const timeSinceActive = new Date().getTime() - lastActiveTimestamp;

        // Auto refresh only if document is active and mouse was last moved within activity limit
        if (!isRefresh || (document.hidden === false && timeSinceActive < INACTIVITY_LIMIT)) {
          await method(isRefresh);
        }

        isRefresh = true;
        await sleep(delay);
      }
    };

    run();

    return () => {
      isRunning = false;
    };
  }, [method, delay]);
};

let lastActiveTimestamp = 0;

const handleMouseMove = () => {
  lastActiveTimestamp = new Date().getTime();
};

handleMouseMove();

document.addEventListener("mousemove", handleMouseMove, false);

const INACTIVITY_LIMIT = 1000 * 60 * 15;
